module.exports = "<div id=\"main-page\">\r\n  <flash-messages></flash-messages>\r\n  <router-outlet></router-outlet>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 5